module.exports = __webpack_public_path__ + "static/media/Vector.c7d71f5e.svg";